import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable()
export class DocumentService {

  constructor(private http: HttpClient) {}

  get(id: number) {
    return this.http.get(`${environment.apiUrl}/api/v1/user/document?id=${id}`, {
      responseType: 'blob'
    })
  }

}
